module.exports = __webpack_public_path__ + "3dc958c4.svg";